
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.998 3.588a.9.9 0 01.9.9V7.09h2.613a.9.9 0 01.893.788l.007.112a.9.9 0 01-.9.9H8.898v2.621a.9.9 0 01-.787.893l-.113.007a.9.9 0 01-.9-.9v-2.62H4.49a.9.9 0 01-.893-.787l-.007-.113a.9.9 0 01.9-.9H7.1V4.488a.9.9 0 01.786-.893z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    